import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { CheckboxField } from './checkbox-field.component';
import { DatePickerField } from './date-picker-field.component';
import { FileField } from './file-field.component';
import { FormButton } from './form-button.component';
import { InputChipField } from './input-chip-field.component';
import { SelectField } from './select-field.component';
import { SelectMultipleField } from './select-multiple-field.component';
import { SelectPopoverField } from './select-popover-field.component';
import { TextAreaField } from './text-area-field.component';
import { TextField } from './text-field.component';

/**
 * Form and field contexts for TanStack Form integration.
 * Provides access to field state and form state throughout the component tree.
 */
export const { fieldContext, useFieldContext, formContext, useFormContext } = createFormHookContexts();

/**
 * Pre-configured form hook with all available field and form components.
 */
export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  fieldComponents: {
    CheckboxField,
    DatePickerField,
    FileField,
    InputChipField,
    SelectField,
    SelectMultipleField,
    SelectPopoverField,
    TextAreaField,
    TextField,
  },
  formContext,
  formComponents: {
    FormButton,
  },
});
